<template>
  <div class="header">
    <img class="header-logo" src="../../assets/img/logo.svg" alt="TMS" />
    <!-- <img
      class="header-logo mobile"
      src="../../assets/img/login/logo.svg"
      alt="TMS"
    /> -->
    <div v-if="getLoading" class="loading-container">
      <img class="loading" src="../../assets/img/loading.svg" alt="loading" />
    </div>
    <div class="header-nav">
      <router-link
        class="header-nav-tab"
        exact-active-class="header-nav-tab-active"
        to="/planning"
      >
        <span class="tms2 mobile-inline">F</span>
        <span class="desktop">{{ $t("planning") }}</span>
        <span class="mobile-text">{{ $t("planning") }}</span>
      </router-link>
      <router-link
        v-if="getUser.permissions.isAdmin || getUser.permissions.isSuperAdmin"
        class="header-nav-tab"
        exact-active-class="header-nav-tab-active"
        :class="{
          'header-nav-tab-active': this.$route.name === 'inquiry',
        }"
        to="/inquiry"
      >
        <span class="tms2 mobile-inline">A</span>
        <span class="desktop">{{ $t("inquiries") }}</span>
        <span class="mobile-text">{{ $t("inquiries") }}</span>
      </router-link>
      <router-link
        v-if="
          getUser.permissions.isSuperAdmin ||
          getUser.permissions.isAdmin ||
          getUser.permissions.isReporter
        "
        class="header-nav-tab"
        exact-active-class="header-nav-tab-active"
        to="/reports/own"
        :class="{
          'header-nav-tab-active':
            this.$route.name === 'newReport' ||
            this.$route.name === 'editReport',
          'header-nav-tab-active':
            this.$route.path === '/reports/new' ||
            this.$route.path === '/reports/own' ||
            this.$route.name === 'editReport',
        }"
      >
        <span class="tms2 mobile-inline">B</span>
        <span class="desktop">{{ $t("reports") }}</span>
        <span class="mobile-text">{{ $t("reports") }}</span>
      </router-link>
      <router-link
        v-if="getUser.permissions.isAdmin || getUser.permissions.isSuperAdmin"
        class="header-nav-tab"
        exact-active-class="header-nav-tab-active"
        to="/companies"
        :class="{
          'header-nav-tab-active':
            this.$route.name === 'newCompany' ||
            this.$route.name === 'editCompany' ||
            this.$route.name === 'newProject' ||
            this.$route.name === 'newObject' ||
            this.$route.name === 'newPart' ||
            this.$route.name === 'getPart',
        }"
      >
        <span class="tms2 mobile-inline">C</span>
        <span class="desktop">{{ $t("companies") }}</span>
        <span class="mobile-text">{{ $t("companies") }}</span>
      </router-link>
      <router-link
        class="header-nav-tab"
        exact-active-class="header-nav-tab-active"
        to="/users"
        v-if="getUser.permissions.isAdmin || getUser.permissions.isSuperAdmin"
      >
        <span class="tms2 mobile-inline">D</span>
        <span class="desktop">{{ $t("users") }}</span>
        <span class="mobile-text">{{ $t("users") }}</span>
      </router-link>
    </div>
    <div class="header-top-right">
      <!-- <div
        class="search-input-wrapper"
        v-if="
          this.$route.name !== 'inquiry' &&
          this.$route.name !== 'log' &&
          this.$route.name !== 'calendar'
        "
      >
        <input
          class="search-input"
          type="text"
          placeholder="Търсене"
          @keyup="sendSearchInput()"
          v-model="search"
        /> 
      </div> -->
      <div
        class="header-toggle header-search"
        v-if="
          this.$route.name !== 'inquiry' &&
          this.$route.name !== 'log' &&
          this.$route.name !== 'calendar'
        "
        @click="showInput()"
      >
        <span class="tms">N</span>
      </div>
      <div
        class="search-input-wrapper"
        v-show="
          isSearchShown == true &&
          this.$route.name !== 'inquiry' &&
          this.$route.name !== 'log' &&
          this.$route.name !== 'calendar'
        "
      >
        <input
          class="search-input"
          type="text"
          placeholder="Търсене"
          v-model="search"
          ref="searchInputField"
          @keyup="sendSearchInput()"
        />
      </div>
      <div
        class="vl desktop"
        v-if="
          this.$route.name !== 'inquiry' &&
          this.$route.name !== 'log' &&
          this.$route.name !== 'calendar'
        "
      ></div>
      <!-- <div class="header-toggle">
        <a
          title="Отворете старата версия (само за четене)"
          class="header-user"
          href="https://old-smr.vaspro.bg/"
          target="_blank"
        >
          <div class="desktop">
            <p class="old-version">⏲️ Стара Версия</p>
          </div>
        </a>
      </div> 
      <div class="vl desktop"></div> -->
      <!-- 
        <div class="header-toggle">
          <a title="Научете повече за новите функции" class="header-user" :href="whatsnewPdf" target="_blank">
            <div class="desktop">
              <p>💡 Какво е новото?</p>
            </div>
          </a>
        </div> 
        <div class="vl desktop"></div>-->
      <div
        class="header-toggle"
        v-if="getUser.permissions.isSuperAdmin"
        @click="goToLog()"
      >
        <span class="tms">{{ "[" }}</span>
      </div>
      <div class="vl desktop" v-if="getUser.permissions.isSuperAdmin"></div>

      <div
        class="header-toggle"
        v-if="getUser"
        @click="isUserModalOpened = true"
      >
        <span class="tms">B</span>
        <!-- <div class="desktop">
            <p>{{ getUser.name }}</p>
          </div> -->
      </div>
      <div class="vl desktop"></div>
      <span class="header-toggle" @click="logout()">
        <span class="tms">F</span></span
      >
    </div>
    <transition name="fade">
      <div class="voice-listener" v-if="voiceListening">
        <div class="voice-listener-inner">
          <div class="voice-listener-inner">
            <div class="voice-listener-inner">
              <div class="voice-listener-inner"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <UserModalToggle
        v-if="isUserModalOpened"
        :idToEdit="getUser._id"
        :limitedFunctionality="true"
        :userMode="true"
      />
    </transition>
    <transition name="fade">
      <VoiceCommandsModal v-if="isVoiceCommandsModalOpened" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserModalToggle from "./UserModalToggle";
import VoiceCommandsModal from "./VoiceCommandsModal";
// import voiceRecognition from '../mixins/voiceRecognition';
export default {
  components: {
    UserModalToggle,
    VoiceCommandsModal,
  },
  // mixins: [voiceRecognition],
  watch: {
    "$route.name"(to) {
      // don't reset search if route is 'newPart' or 'getPart', because that will make
      // a request to get all companies again and will reset the companies dropdown tree
      if (
        to !== "newPart" &&
        to !== "getPart" &&
        to !== "newProject" &&
        to !== "newObject"
      ) {
        this.search = "";
        this.sendSearchInput();
      }
    },
  },
  data() {
    return {
      isUserModalOpened: false,
      isVoiceCommandsModalOpened: false,
      keydownFired: false,
      search: "",
      isSearchShown: false,
      voiceListening: false,
      recognition: null,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      "getLoading",
      // ...
    ]),
    whatsnewPdf() {
      return `${process.env.VUE_APP_FILES_URI}/vas-what-s-new.pdf`;
    },
  },
  methods: {
    // initVoiceRecognition() {
    //   const stored = JSON.parse(localStorage.getItem('voiceListening'));

    //   if (stored) {
    //     this.voiceListening = true;
    //     this.startVoiceRecognition();
    //   } else if (stored === undefined || stored === null) {
    //     localStorage.setItem('voiceListening', false);
    //   }
    // },
    toggleVoiceRecognition() {
      this.voiceListening = !this.voiceListening;
      // localStorage.setItem('voiceListening', this.voiceListening);

      if (this.voiceListening) {
        this.startVoiceRecognition();
      } else {
        this.recognition.stop();
      }
    },
    startVoiceRecognition() {
      this.recognition = new (window.speechRecognition ||
        window.webkitSpeechRecognition ||
        window.mozSpeechRecognition ||
        window.msSpeechRecognition)();
      this.recognition.lang = "bg-BG";
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 5;
      // this.recognition.continuous = true;

      this.recognition.start();

      this.recognition.onresult = (event) => {
        for (const i of event.results[event.results.length - 1]) {
          if (i.transcript.toLowerCase().includes("нов отчет")) {
            if (this.$route.name !== "editReport") {
              this.$router.push("/reports/new");
            }
            return;
          } else if (
            i.transcript.toLowerCase().includes("отвори отчети") ||
            i.transcript.toLowerCase().includes("моите отчети")
          ) {
            this.$router.push("/reports/own");
            return;
          } else if (i.transcript.toLowerCase().includes("отвори справки")) {
            this.$router.push("/inquiry");
            return;
          } else if (i.transcript.toLowerCase().includes("отвори планиране")) {
            this.$router.push("/planning");
            return;
          } else if (i.transcript.toLowerCase().includes("отвори фирми")) {
            this.$router.push("/companies");
            return;
          } else if (
            i.transcript.toLowerCase().includes("отвори потребители")
          ) {
            this.$router.push("/users");
            return;
          } else if (i.transcript.toLowerCase().includes("планирай обекти")) {
            this.$router.push("/planning?plan=true");
            return;
          } else if (
            i.transcript
              .toLowerCase()
              .includes("направи справка за текущия месец")
          ) {
            if (this.$route.name === "inquiry") {
              this.$eventBus.$emit(
                "makeInquiryFromSpeechRecognition",
                "current"
              );
            } else {
              this.$router.push(
                `/inquiry?fromDate=${this.getDates(
                  0
                ).from.toISOString()}&toDate=${this.getDates(
                  0
                ).to.toISOString()}&period=current&voice=true`
              );
            }
            return;
          } else if (
            i.transcript
              .toLowerCase()
              .includes("направи справка за миналия месец")
          ) {
            if (this.$route.name === "inquiry") {
              this.$eventBus.$emit(
                "makeInquiryFromSpeechRecognition",
                "previous"
              );
            } else {
              this.$router.push(
                `/inquiry?fromDate=${this.getDates(
                  1
                ).from.toISOString()}&toDate=${this.getDates(
                  1
                ).to.toISOString()}&period=previous&voice=true`
              );
            }
            return;
          } else if (
            i.transcript.toLowerCase().includes("експорт") ||
            i.transcript.toLowerCase().includes("експортирай")
          ) {
            this.$eventBus.$emit("export");
            return;
          } else if (i.transcript.toLowerCase().includes("смени ми паролата")) {
            this.isUserModalOpened = true;
            return;
          } else if (i.transcript.toLowerCase().includes("назад")) {
            this.$router.go(-1);
            return;
          } else if (
            i.transcript.toLowerCase().includes("отказ") ||
            i.transcript.toLowerCase().includes("затвори")
          ) {
            this.$eventBus.$emit("closeModalFromSpeechRecognition");
            return;
          } else if (
            i.transcript.toLowerCase().includes("спри да слушаш") ||
            i.transcript.toLowerCase().includes("стоп")
          ) {
            this.voiceListening = false;
            this.recognition.stop();
            return;
          }
        }
      };

      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(function (stream) {
          // Handle the incoming audio stream
          // const bars = []; // We'll use this later
          const audioContext = new AudioContext();
          const input = audioContext.createMediaStreamSource(stream);
          const analyser = audioContext.createAnalyser();
          const scriptProcessor = audioContext.createScriptProcessor();

          // Some analyser setup
          analyser.smoothingTimeConstant = 0.3;
          analyser.fftSize = 1024;

          input.connect(analyser);
          analyser.connect(scriptProcessor);
          scriptProcessor.connect(audioContext.destination);
        })
        .catch(function (err) {
          console.log(err);
          /* handle the error */
        });

      this.recognition.onend = () => {
        this.voiceListening = false;
        // if (this.voiceListening) {
        //   recognition.start();
        // }
      };
    },
    getDates(months) {
      const date = new Date();
      // set first day of previous month
      let startDate = new Date(date.getFullYear(), date.getMonth() - months, 1);
      startDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      let toDate = new Date(
        date.getFullYear(),
        date.getMonth() + months + 1,
        0
      );
      toDate.setHours(23, 59, 59, 999);

      return {
        from: startDate,
        to: toDate,
      };
    },
    goToLog() {
      this.$router.push("/log");
    },
    logout() {
      this.$store
        .dispatch("logout")
        .then(() => this.$router.push("/login"))
        .catch((err) => console.log(err));
    },
    // Send searched string globally
    sendSearchInput() {
      this.$root.$emit("sendSearchInput", this.search);
    },
    showInput() {
      this.isSearchShown = !this.isSearchShown;
      if (this.isSearchShown) {
        this.$nextTick(() => {
          this.$refs["searchInputField"].focus();
        });
      }
      this.search = "";
    },
    handleKeydown(event) {
      if (event.key === "Alt") {
        event.preventDefault();
        let hold = true;

        window.addEventListener(
          "keyup",
          () => {
            hold = false;
            this.keydownFired = false;
            return false;
          },
          { once: true }
        );

        if (!this.keydownFired) {
          setTimeout(() => {
            if (hold) {
              this.toggleVoiceRecognition();
              return false;
            }
          }, 500);
        }

        this.keydownFired = true;
      }
    },
  },
  mounted() {
    this.$on("closeUserToggleModal", (result) => {
      this.isUserModalOpened = false;
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch((err) => console.log(err));
      }
    });
    // this.initVoiceRecognition();
    this.$on("closeVoiceCommandsModal", () => {
      this.isVoiceCommandsModalOpened = false;
    });

    // window.addEventListener("keydown", this.handleKeydown);
  },
  destroyed() {
    this.$off("closeUserToggleModal");
    this.$off("closeVoiceCommandsModal");
    // window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>

<style scoped lang="scss">
.header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  background: #374e85;
  height: 40px;
  padding: 0 40px;
  width: 100%;
}

.header-nav {
  align-items: flex-end;
  display: flex;
  width: 100%;
}

.header-logo {
  height: 20px;
}

.header-top-right {
  align-items: center;
  display: flex;
  gap: 5px;
}

.header-toggle {
  align-items: center;
  border-radius: 1px;
  cursor: pointer;
  display: flex;
  height: 31px;
  padding: 0 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
  .tms,
  .tms2 {
    color: #fff;
    font-size: 16px;
  }
  .voice {
    margin-right: 0;
  }
  p {
    color: #fff;
    font-size: 12px;
  }
}

/* HEADER BOTTOM */
.header-nav {
  align-items: flex-end;
  display: flex;
  gap: 3px;
  height: 40px;
  .header-nav-tab {
    align-items: center;
    background-color: rgba(240, 240, 247, 0.2);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    color: #fff;
    font-size: 12px;
    display: inline-flex;
    justify-content: center;
    padding: 6px 15px;
    text-transform: uppercase;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    white-space: nowrap;

    &:hover {
      background-color: rgba(240, 240, 247, 0.3);
    }
    &.header-nav-tab-active {
      background-color: #f0f0f7;
      color: #000;
      &:hover {
        background-color: #f0f0f7;
      }
    }
  }
}

.search-input-wrapper {
  background: #ffffff;
  border-radius: 4px;
  position: relative;
  width: 100px;

  // &::before {
  //   color: #374e85;
  //   content: "N";
  //   font-family: "tms";
  //   font-size: 16px;
  //   left: 10px;
  //   position: absolute;
  //   top: 50%;
  //   transform: translateY(-50%);
  // }
  .search-input {
    background-color: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 1px;
    caret-color: #374e85;
    color: #374e85;
    height: 100%;
    padding: 5px 15px 5px 5px;
    width: 100%;
    ::placeholder {
      color: #374e85;
    }
  }
}

.mobile,
.mobile-inline,
.mobile-text {
  display: none;
}

.voice-listener {
  align-items: center;
  animation: pulse 1s infinite ease-in-out;
  background-color: rgba(117, 44, 243, 0.2);
  border-radius: 50%;
  bottom: 0;
  display: flex;
  height: 50vw;
  justify-content: center;
  left: 50%;
  position: fixed;
  transform: translateX(-50%) translateY(50%);
  width: 50vw;
  z-index: 9999;
}

@keyframes pulse {
  0% {
    background-color: rgba(117, 44, 243, 0.2);
  }

  50% {
    background-color: rgba(117, 44, 243, 0.05);
  }

  100% {
    background-color: rgba(117, 44, 243, 0.2);
  }
}

.voice-listener-inner {
  align-items: center;
  background-color: rgba(117, 44, 243, 0.2);
  border-radius: 50%;
  display: flex;
  height: 85%;
  justify-content: center;
  width: 85%;
}

.vl {
  background-color: #fff;
  height: 30px;
  opacity: 0.5;
  width: 1px;
}

.old-version {
  white-space: nowrap;
}

/* RESPONSIVE */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: flex;
  }

  .mobile-inline {
    display: inline;
  }

  .header {
    height: auto;
    gap: 10px;
    flex-wrap: wrap;
    padding: 10px 5px 0 5px;
    width: 100%;

    .header-logo {
      width: 150px;
    }

    .header-top-right {
      gap: 0;

      .header-toggle {
        padding: 0 5px;

        .tms {
          font-size: 20px;
        }
      }
    }
  }

  .header-nav {
    order: 3;
    width: 100%;

    .header-nav-tab {
      gap: 2px;
      flex-direction: column;
      height: 100%;
      order: 3;
      padding: 0;
      width: 100%;
      .tms2 {
        font-size: 14px;
      }
      .mobile-text {
        display: inline-block;
        font-size: 8px;
      }
    }
  }

  .header-nav-left {
    justify-content: center;
    width: 100%;
  }

  .search-input-wrapper {
    width: 75px;

    // &::before {
    //   display: none;
    // }
    // .search-input {
    //   padding: 5px 15px 5px 5px;
    // }
  }

  .header-toggle .tms,
  .header-toggle .tms2 {
    margin: 0;
  }

  .toggle-voice-recognition {
    align-items: center;
    background-color: #752cf3;
    border-radius: 50%;
    bottom: 20px;
    display: flex;
    height: 50px;
    justify-content: center;
    left: 20px;
    position: fixed;
    width: 50px;
    z-index: 10;
  }

  .toggle-voice-recognition:hover {
    background-color: #752cf3;
  }
}

@media print {
  .header {
    display: none;
  }
}
</style>
